<template>
  <div class="app-container">
    <CrudTable entity="Yarn" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['number', 'description', { field: 'planningOrder', label: 'yarn.planningOrder' }]
    };
  },
  methods: {
    generateSummary({ number }) {
      return `${number}`;
    }
  }
};
</script>
